import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { Property } from 'shared-types/Property';

import ForgottenPasswordV1 from './containers/ForgottenPassword';
import { ForgottenPasswordV2 } from './v2';

type ForgottenPasswordVersionProps = {
  language: string;
  property: Property;
};

export const ForgottenPasswordVersion: FC<ForgottenPasswordVersionProps> = ({
  language,
  property,
}) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <ForgottenPasswordV2 language={language} property={property} />;
  return <ForgottenPasswordV1 language={language} propertyId={property.id} />;
};
